import React from 'react';
import {generateColumnClass} from "../../Utility";

const SwitchInput = ({name, value, error, label, onChange, onBlur, columns, inline, aligned}) => {
    const columnClass = generateColumnClass(columns);
    const className = `${inline ? 'd-flex flex-column justify-content-end ' : ''}col-12${columnClass}`;

    return (
        <div className={className}>
            {aligned &&
                <label className={`form-label opacity-75${inline ? ' mb-0 py-2 col-12 col-md-4' : ''}`}>
                    &nbsp;
                </label>
            }
            <div className={`form-check form-switch py-2${inline ? ' offset-md-4' : ''}${aligned ? ' m-0' : ''}`}>
                <input type="checkbox"
                       className="form-check-input me-3"
                       name={name}
                       checked={value}
                       onChange={onChange}
                       onBlur={onBlur}
                       role="switch"
                       id={name}/>
                <label className="form-check-label fw-medium fs-sm opacity-75"
                       htmlFor={name}>
                    {label}
                </label>
            </div>
            {error && <div className="form-text text-start text-danger">{error}</div>}
        </div>
    )
};
export default SwitchInput;
